function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 8C1.5 4.41042 4.41043 1.5 8 1.5C11.5896 1.5 14.5 4.41042 14.5 8C14.5 11.5896 11.5896 14.5 8 14.5C4.41043 14.5 1.5 11.5896 1.5 8ZM8 0C3.582 0 0 3.58199 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM8.93332 4.1C9 4.16667 9 4.3 9 4.43333V8.56667C9 8.83333 8.86667 9.03333 8.66666 9.23333C8.46667 9.43333 8.26666 9.5 8 9.5C7.73334 9.5 7.53333 9.43333 7.33334 9.23333C7.13333 9.03333 7 8.83333 7 8.56667V4.43333C7 4.16667 7.13333 3.96667 7.33334 3.76667C7.53333 3.56667 7.73334 3.5 8 3.5C8.13333 3.5 8.26666 3.56667 8.39999 3.63333C8.53333 3.7 8.66666 3.76667 8.73334 3.83333C8.79999 3.9 8.86667 3.96667 8.93332 4.1ZM7.33334 10.7C7.46667 10.5 7.73334 10.4333 8 10.4333C8.26666 10.4333 8.53333 10.5 8.66666 10.7C8.86667 10.8333 8.93332 11.1 8.93332 11.3667C8.93332 11.6333 8.86667 11.8333 8.66666 12.0333C8.53333 12.2333 8.26666 12.3 8 12.3C7.73334 12.3 7.53333 12.2333 7.33334 12.0333C7.13333 11.9 7.06668 11.6333 7.06668 11.3667C7.06668 11.1 7.20001 10.9 7.33334 10.7Z"
});

function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.86ac6c3d619fc6bdae1a42080b56bd1e.svg";
export { ForwardRef as ReactComponent };